import React, { useState } from 'react';
import './FAQSection.scss';
import { useGetFaqsByType } from 'hooks/faqs';

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        {question}
        <span className="toggle-icon">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && <p className="faq-answer">{answer}</p>}
    </div>
  );
};


const FAQSection: React.FC = () => {
  const { faqs, isLoading } = useGetFaqsByType("lifetime");
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px] text-gray-500">
        Loading...
      </div>
    );
  }
  const sortedFaqs = (faqs ?? []).sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));

  return (
    <section className="faq-section">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {sortedFaqs?.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;